import styled from 'styled-components';

export const StyledQrCodePopup = styled.div`
  background: ${({ theme }) => theme.background};
  width: calc(${({ theme }) => theme.qrCodeSize} + 24px * 2);
  max-width: calc(${({ theme }) => theme.qrCodeSize} + 24px * 2);
  padding: 24px;

  .qr-code-popup-label-wrapper {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: end;
    gap: 24px;
    margin-top: 24px;

    img {
      height: 48px;
      width: 48px;
    }
  }

  .qr-code-popup-label {
    text-transform: uppercase;
    font-family: "BebasNeue";
    font-size: 2.5rem;
    color: white;
    font-weight: 400;
  }
`;
